import { Typography } from '@metrika/ui-kit';
import { Button } from '@metrika/ui-kit/carbon';
import React, { useEffect, useState, memo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import * as storage from '../../_shared/utils/storage';
import { PrivacyNoticeButtons, PrivacyNoticeContainer, PrivacyNoticeText } from './styles';

export const CookieModal = memo(() => {
   const [consentComplete, setConsentComplete] = useState(true);

   useEffect(() => {
      const [, consentComplete] = storage.getItem(localStorage, 'consentCompleteNew');
      setConsentComplete(consentComplete === 'true');
   }, []);

   const consentCompleteHandler = (acceptAll = false) => {
      storage.setItem(localStorage, 'consentCompleteNew', 'true');
      setConsentComplete(true);
      storage.setItem(localStorage, 'analyticsOkNew', acceptAll ? 'true' : 'false');
      if (acceptAll) {
         window.location.reload();
      }
   };

   const { pathname } = useLocation();
   if (consentComplete || pathname === '/privacy') return null;
   return (
      <PrivacyNoticeContainer>
         <PrivacyNoticeText>
            <div>
               <Typography.H2>Privacy Notice</Typography.H2>
               <Typography className={'showMobile'}>
                  <Link to="/privacy" className={'cds--link'}>
                     View our Privacy Policy
                  </Link>
               </Typography>
            </div>
            <Typography>
               Metrika stores data on your browser to understand how the Metrika platform is used and to give you the
               best possible experience. By opting out, Metrika will not store any cookies that aren’t necessary for the
               Metrika Platform to operate.
            </Typography>
            <Typography className={'hideMobile'}>
               <Link className="cds--link" to="/privacy">
                  Learn more in our Privacy Policy.
               </Link>
            </Typography>
         </PrivacyNoticeText>
         <PrivacyNoticeButtons>
            <Button
               kind="primary"
               onClick={() => {
                  consentCompleteHandler(true);
               }}
            >
               Accept
            </Button>
            <Button
               kind="secondary"
               onClick={() => {
                  consentCompleteHandler();
               }}
            >
               Opt Out
            </Button>
         </PrivacyNoticeButtons>
      </PrivacyNoticeContainer>
   );
});
